module.exports = __webpack_public_path__ + "img/Outreach.b8c1cfa4.png";